export default function (extension?: string): boolean {
	const imageExtensionList: string[] = ['JPEG', 'JPG', 'PNG', 'GIF'];
	extension = extension[0] == '.' ? extension.substring(1) : extension;
	return imageExtensionList.includes(extension.toUpperCase());
}
